<template>
    <form-element style="display: flex; flex-direction: column;flex-grow:1; min-width: 320px;">
        <h2 style="text-align:center;margin-block-end:0.1em">Wertung Technik</h2>
        <div id="Wertung">
            <h2 class="wertungfont">{{currentValue}}</h2>
        </div>
        <div id="header" class="wertungheader">
            <div id="header_left" class="wertungheader_left">
                <button id="technic03" @click="onTechnic03Click" class="buttonKRWertungTechnik0_3" v-haptic="200"><h1>-0,3</h1></button>
            </div>
            <div id="header_right" class="wertungheader_right">
                <button id="technic01" @click="onTechnic01Click" class="buttonKRWertungTechnik0_1" v-haptic="200"><h1>-0,1</h1></button>
            </div>
        </div>
        <div id="Trenner">&nbsp;</div>
        <div id="Korrektur" class="wertungkorrekturContainer">
            <div id="KorrekturButton" class="wertungkorrekturElement">
                <button id="revert" @click="onRevertClick" class="buttonKRWertungTechnikKorrektur" v-haptic="200"><h3>Korrektur</h3></button>
            </div>
        </div>
    </form-element>
</template>
<script>
    import { FormElement } from '@progress/kendo-vue-form';
    import store from '@/store/store.js';

    export default {
        data: function () {
            return {
                currentValue: 4.0,
                previousValue: 0
            };
        },
        components: {
            'form-element': FormElement,
            store
        },
        props: {
            reset: Number,
        },
        watch: {
            reset() {
                console.log('Reset');
                this.currentValue = 4.0;
                this.previousValue = 0;
                this.kendoForm.onFormReset();
            },
        },
        methods: {
            onTechnic03Click() {
                this.previousValue = this.currentValue;
                const temp = (this.currentValue - 0.3).toFixed(1);
                if (temp >= 0) this.currentValue = temp;
                store.teilnehmer_WertungTechnik = Number(temp);
                console.log("--------> Technik:", store.teilnehmer_WertungTechnik)
            },
            onTechnic01Click() {
                this.previousValue = this.currentValue;
                const temp = (this.currentValue - 0.1).toFixed(1);
                if (temp >= 0) this.currentValue = temp;
                store.teilnehmer_WertungTechnik = Number(temp);
                console.log("--------> Technik:", store.teilnehmer_WertungTechnik)
            },
            onRevertClick() {
                this.currentValue = this.previousValue;
                store.teilnehmer_WertungTechnik = Number(this.currentValue);
                console.log("--------> Technik:", store.teilnehmer_WertungTechnik)
            }
        }
    };
</script>
